import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestissemenDuration } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        partnerFlux: [entity?.parameters?.partnerFlux || null],
        avOptionInvestissementProgressifMontantArbitrage: [
          entity?.parameters
            ?.avOptionInvestissementProgressifMontantArbitrage || null,
          Validators.required,
        ],
        avOptionInvestissementProgressifDuree: [
          entity?.parameters?.avOptionInvestissementProgressifDuree || null,

          Validators.required,
        ],
        avOptionInvestissementProgressifDureeCustom: [
          entity?.parameters?.avOptionInvestissementProgressifDureeCustom ||
            null,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: InvestissemenDuration[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  get partnerFlux() {
    return this.form.get('products')?.get('0')?.get('parameters.partnerFlux');
  }
  extract() {
    const formValues = _.cloneDeep(this.form.value.products);
    formValues?.forEach(element => {
      if (
        element?.parameters?.avOptionInvestissementProgressifDuree !== 'CUSTOM'
      ) {
        element.parameters.avOptionInvestissementProgressifDureeCustom = null;
      }
    });
    return formValues;
  }
}
